module.exports = __webpack_public_path__ + "img/ics_o_contactNote.a360589e.svg";